export default function Council2024Entries() {
    return (
        <table id="filetable">
                                {/*Start Table*/}
                                <tr>
                                  <th id="a-m">Meeting Date</th>
                                  <th>Minutes</th>
                                  <th>Agenda</th>
                                </tr>
                                {/*Start File*/}
                                <tr>
                                  <td>12-17-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-12-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>11-19-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-11-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-11-19-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>10-15-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-10-15-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-10-15-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>09-17-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-09-17-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-09-17-BCAgenda.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>08-20-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-08-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>07-16-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-07-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>06-18-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-06-18-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>05-21-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-05-21-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>04-16-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-04-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>03-19-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-03-19-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>03-07-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-03-07-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>02-20-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-02-20-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>01-24-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-01-24-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>01-16-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-01-16-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                                {/*Start File*/}
                                <tr>
                                  <td>01-02-2024</td>
                                  <td>
                                    <a href="../docs/council/minutes/2024/2024-01-02-BCMinutes.pdf" target="_blank" rel="noopener noreferrer">
                                      <i className="fa-solid fa-file-pdf fa-xl"></i>
                                      &nbsp; Available
                                    </a>
                                  </td>
                                  <td>Unavailable</td>
                                </tr>
                                {/*End File*/}
                              </table>
    )
}